<template>
  <div class="home">
    <div class="header">
        <!-- <el-button size="mini" type="primary" plain>新增</el-button> -->
    </div>
    <div>
      <el-table :data="tableData" stripe style="width: 100%" border size="mini">
        <el-table-column align="center" type="index" label="序号" width="50" />
        <el-table-column align="center" prop="name" label="盘组名称" width="180" />
        <el-table-column align="center" prop="pzlx" label="盘组类型" width="180" />
        <el-table-column align="center" prop="mac" label="Mac地址" />
        <el-table-column align="center" prop="ps" label="盘数" />
        <el-table-column align="center" prop="remark" label="备注" />
        <el-table-column align="center" label="操作">
            <template v-slot="scope">
            <el-button type="text" size="small" @click="update(scope.row)">更新</el-button>
            <!-- <el-button type="text" size="small" @click="del(scope.row.id)">删除</el-button> -->
            </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
        v-model="innerVisible"
        width="40%"
        title="税盘设备更新"
        append-to-body
      >
        <el-button type="text" @click="writeSkpkl">填写税控盘口令</el-button>
        <el-button type="text" @click="writeZskl">填写证书口令</el-button>
        <el-table :data="deviceData" style="width: 100%" height="500" border size="mini" @selection-change="handleSelectionChange">
          <el-table-column align="center" type="selection" min-width="55" />
          <el-table-column align="center" type="index" label="序号" min-width="50" />
          <el-table-column align="center" prop="skpph" label="税控盘编号" min-width="120"/>
          <el-table-column align="center" prop="skpkl" label="税控盘口令" min-width="120">
            <template v-slot="scope">
              <el-input size="mini" v-model="scope.row.skpkl"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="zskl" label="证书口令" min-width="120">
            <template v-slot="scope">
              <el-input size="mini" v-model="scope.row.zskl"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="zt" label="状态" min-width="120">
            <template v-slot="scope">
              <span style="color:red" v-if="scope.row.zt == 0">未添加</span>
              <span style="color:green" v-if="scope.row.zt == 1">已添加</span>
            </template>
          </el-table-column>
        </el-table>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="next" size="mini" type="primary" plain>下一步</el-button>
          </span>
        </template>
    </el-dialog>

    <el-dialog v-model="centerDialogVisible" title="税盘添加状态" width="30%" center >
        <div style="height:400px;overflow-y:scroll">
        <div v-for="item in ztResult" :key="item.zz">
        <li v-if="item.cwxx">{{item.cwxx}}</li>
        <li v-else>
            <span class="spzt">税盘：{{item.jqbh}}</span>
            <span style="color:red" v-if="item.zt == '失败'">添加{{item.zt}}</span>
            <span style="color:green" v-if="item.zt == '成功'">添加{{item.zt}}</span>
            <!-- 添加<span class="spzt">{{item.zt}}</span> -->
            <span class="spzt">原因：{{item.xx}}</span>
        </li>
        </div >
        </div>
        <template #footer>
        <span class="dialog-footer">
            <el-button @click="centerDialogVisible = false">关闭</el-button>
        </span>
        </template>
    </el-dialog>
  </div>
</template>

<script>
import { zyDeviceList ,zyDeviceUpdateList, zyDeviceUpdates } from "@/api/ea";
export default {
    data(){
        return{
            tableData:[],
            listQuery:{
                mac:'',
                rel:'',
                items:[],
            },
            innerVisible:false,
            deviceData:[],
            centerDialogVisible:false,
            ztResult:[],
            value:[],
        }
    },
    created(){
       this.getList()
    },
    methods:{
        getList(){
            zyDeviceList().then(res=>{
                this.tableData = res.data.data.list
            })
        },
        del(id){
            console.log(id);
        },
        update(val){
            this.innerVisible = true
            this.listQuery.mac = val.mac
            this.listQuery.rel = val.rel
            zyDeviceUpdateList({mac:val.mac}).then(res=>{
                this.deviceData = res.data.data.list
            })
        },
        next(){
            let items = this.deviceData.filter(v=>{
                if(v.zt != 1){
                return {
                    skpkl: v.skpkl,
                    skpph: v.skpph,
                    zskl: v.zskl,
                }
                }
            })
            if(items.length == 0){
                this.$qzfMessage("无可添加的税控盘",1)
                return
            }
            let param = {
                rel: this.listQuery.rel,
                mac: this.listQuery.mac,
                items,
            }
            zyDeviceUpdates(param).then(res=>{
                console.log(res.data.data.list);
                this.ztResult = res.data.data.list
                if(res.data.msg == "success"){
                this.centerDialogVisible = true
                this.innerVisible = false
                }
            })
        },
        handleSelectionChange(val){
            this.value = val
        },
        writeSkpkl() {
            if(this.value.length == 0){
                this.$qzfMessage("请至少选择一条", 1)
                return
            }
            this.$prompt('请输入税控盘口令', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                // 成功的操作 写在这里
                this.value.map(v=>{
                v.skpkl = value
                })
            }).catch(() => {    
            });
        },
        writeZskl() {
            if(this.value.length == 0){
                this.$qzfMessage("请至少选择一条", 1)
                return
            }
            this.$prompt('请输入证书口令', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                // 成功的操作 写在这里
                this.value.map(v=>{
                v.zskl = value
                })
            }).catch(() => {      
            });
        },
    }
}
</script>

<style lang="scss" scoped>
</style>